import { API } from "../../../cache";

function detailToMessage(detail, fallback) {
  if (!detail) return fallback;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail.map((d) => d?.msg).filter(Boolean).join("; ") || fallback;
  }
  return detail.message || fallback;
}

async function request(path, { method = "GET", body } = {}) {
  let res;
  try {
    res = await fetch(`${API}${path}`, {
      method,
      credentials: "include",
      headers: body ? { "Content-Type": "application/json" } : undefined,
      body: body ? JSON.stringify(body) : undefined,
    });
  } catch {
    throw new Error("Can't reach ProTrack. Check your connection and try again.");
  }
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const err = new Error(detailToMessage(data?.detail, `Request failed (${res.status})`));
    err.status = res.status;
    throw err;
  }
  return data;
}

export const emailAuthApi = {
  linkInfo: (token) => request(`/auth/email/link-info?token=${encodeURIComponent(token)}`),
  registerStart: (payload) => request("/auth/email/register/start", { method: "POST", body: payload }),
  registerConfirm: (token, code) => request("/auth/email/register/confirm", { method: "POST", body: { token, code } }),
  login: (email, password) => request("/auth/email/login", { method: "POST", body: { email, password } }),
  verify: (code) => request("/auth/email/login/verify", { method: "POST", body: { code } }),
  forgotPassword: (email) => request("/auth/email/forgot-password", { method: "POST", body: { email } }),
  resetPassword: (payload) => request("/auth/email/reset-password", { method: "POST", body: payload }),

  // Admin (Users page)
  sendInvite: (userId) => request(`/users/${userId}/email-login/invite`, { method: "POST" }),
  resetTotp: (userId) => request(`/users/${userId}/email-login/reset-totp`, { method: "POST" }),
};

// Mirrors app/services/email_auth.py password_problems() — the server is the
// real check; this only drives the live checklist.
export const PASSWORD_RULES = [
  { key: "len", label: "At least 8 characters", test: (pw) => pw.length >= 8 },
  { key: "num", label: "At least 1 number", test: (pw) => /\p{N}/u.test(pw) },
  {
    key: "special",
    label: "At least 2 special characters",
    test: (pw) => (pw.match(/[^\p{L}\p{N}\s]/gu) || []).length >= 2,
  },
];

export function passwordIsValid(pw) {
  return PASSWORD_RULES.every((r) => r.test(pw || ""));
}
